
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';

import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
//import { TimeZoneService } from 'src/app/shared/time-zone.service';
//import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
//import { ScheduleService } from '../../services/schedule.service';
//import { JsonPipe } from '@angular/common';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { ScheduleEvent } from '../../../shared/models/ScheduleModels';
import { ScheduleService } from '../../../shared/services/schedule.service';
import { MatInputModule } from '@angular/material/input';
import { TimeZoneService } from '../../../shared/services/time-zone.service';
import { TranslatePipe } from '@ngx-translate/core';
import { UpperCasePipe } from '@angular/common';


@Component({
  selector: 'app-add-event-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatInputModule, MatCheckboxModule, MatDialogModule, MatDatepickerModule, MatButtonModule, TranslatePipe, UpperCasePipe],
  templateUrl: './add-event-dialog.component.html',
  styleUrl: './add-event-dialog.component.css',
  /* providers:[
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
  ],   */
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddEventDialogComponent implements OnInit {

  public addEventForm: FormGroup;
  zones: string[];
  currentTimezone: string;
  isUpdate: boolean = false;
  isEditable: boolean = false;
  theEvent: ScheduleEvent;
  displayTimeZone: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddEventDialogComponent>,
    private fb: FormBuilder,
    private _snackBar: MatSnackBar,
    private eventService: ScheduleService,
    private tzService: TimeZoneService

  ) {
    //console.log(this.data.isEditable);
    this.isEditable = this.data?.isEditable;

    this.currentTimezone = tzService.getCurrentTimezone();
    if (data.Event != null) {
      this.theEvent = this.data.Event;
      this.isUpdate = true;
      this.displayTimeZone = this.data.Event.EventStartTimeZoneIANA;
    }
    else {
      this.displayTimeZone = this.currentTimezone;
    }

  }
  ngOnInit(): void {

    /* this.tzService.getTimezones().subscribe(zones=>{
      //console.log(zones);
      this.zones = zones;
      
      //If users timezone not in timezone json, add it dyanimcally
      if(!this.zones.includes(this.currentTimezone)){
        this.zones.push(this.currentTimezone);
      }

      //If user has saved another timezone than exists in our zones.json, then we have to add it top the list.
      if(this.isUpdate && this.zones.includes(this.theEvent.EventStartTimeZoneIANA)){
        this.zones.push(this.theEvent.EventStartTimeZoneIANA);
      }

    }); */
    //console.log("nGOninit");
    //console.log(this.data.EventDate);

    if (this.isUpdate) {
      var localtime = String(this.theEvent.EventStart.getHours()).padStart(2, "0") + ':' + String(new Date(this.theEvent.EventStart).getMinutes()).padStart(2, "0");
      var localtimeEnd = String(this.theEvent.EventEnd.getHours()).padStart(2, "0") + ':' + String(new Date(this.theEvent.EventEnd).getMinutes()).padStart(2, "0");

      //console.log(localtimeEnd);
      var duration = String(new Date(this.theEvent.Duration).getHours()).padStart(2, "0") + ':' + String(new Date(this.theEvent.Duration).getMinutes()).padStart(2, "0");
      //console.log(!this.theEvent.IsMyEvent);
      this.addEventForm = this.fb.group({
        EventId: this.theEvent.EventId,
        Title: [{ value: this.theEvent.Title, disabled: !this.theEvent.IsMyEvent }, Validators.required],
        UserId: [{ value: this.theEvent.UserId, disabled: !this.theEvent.IsMyEvent }],
        EventStart: { value: this.theEvent.EventStart, disabled: !this.theEvent.IsMyEvent },
        EventStartUTC: this.theEvent.EventStartUTC,
        EventEndUTC: this.theEvent.EventEndUTC,
        EventDate: { value: this.theEvent.EventStart, disabled: !this.theEvent.IsMyEvent },
        EventEndDate: [{ value: this.theEvent.EventEnd, disabled: !this.theEvent.IsMyEvent }, [dateAfterStartValidator('EventDate')]],
        EventEnd: { value: this.theEvent.EventEnd, disabled: !this.theEvent.IsMyEvent },
        EventTime: { value: localtime, disabled: !this.theEvent.IsMyEvent },
        EventEndTime: { value: localtimeEnd, disabled: !this.theEvent.IsMyEvent },
        Duration: { value: this.theEvent.Duration, disabled: !this.theEvent.IsMyEvent },
        EventStartTimeZoneIANA: this.currentTimezone,
        Comment: { value: this.theEvent.Comment, disabled: !this.theEvent.IsMyEvent },
        _PRIVATE: { value: this.theEvent.Visibility == 'PRIVATE', disabled: !this.theEvent.IsMyEvent },
        Visibility: { value: this.theEvent.Visibility, disabled: !this.theEvent.IsMyEvent },
        OrganizationId: this.theEvent.OrganizationId,
      });


    } else {
      //New
      const initialDate = this.getInitialDate();
      this.addEventForm = this.fb.group({
        EventId: '',
        Title: ['', Validators.required],
        UserId: '',
        EventStart: initialDate,
        EventEnd: '',
        EventStartUTC: '',
        EventDate: [initialDate, Validators.required],
        EventEndDate: [initialDate, Validators.required],
        EventTime: ['19:00', Validators.required],
        EventEndTime: ['21:00', Validators.required],
        EventStartTimeZoneIANA: this.currentTimezone,
        Comment: '',
        _PRIVATE: false,
        Visibility: 'ORGANIZATION',
        OrganizationId: '',
      });
    }

    // console.log(this.addEventForm.value);


  }

  private getInitialDate(): Date {
    const incoming = this.data?.selectedDate ?? this.data?.EventDate;

    if (incoming instanceof Date && !isNaN(incoming.getTime())) {
      return incoming;
    }

    const parsed = incoming ? new Date(incoming) : new Date();
    return isNaN(parsed.getTime()) ? new Date() : parsed;
  }


  save() {

    const eventDateControl = this.addEventForm.get("EventDate");
    const eventDateValue = eventDateControl ? eventDateControl.value : null;
    var newEventStart = new Date(eventDateValue);


    const atimeControl = this.addEventForm.get("EventTime");
    const atimeValue = atimeControl ? atimeControl.value : null;

    var hours: number = Number(atimeValue.substring(0, 2));
    var minutes: number = Number(atimeValue.substring(3, 5));
    newEventStart.setHours(hours, minutes, 0);

    const eventEndDateControl = this.addEventForm.get("EventEndDate");
    const eventEndDateValue = eventEndDateControl ? eventEndDateControl.value : null;
    var newEventEnd = new Date(eventEndDateValue);


    const aEndtimeControl = this.addEventForm.get("EventEndTime");
    // console.log(aEndtimeControl);
    const aEndtimeValue = aEndtimeControl ? aEndtimeControl.value : null;
     // console.log(aEndtimeValue);
    //var aEndtime: String = aEndtimeValue.value;
    var hours: number = Number(aEndtimeValue.substring(0, 2));
    var minutes: number = Number(aEndtimeValue.substring(3, 5));
    newEventEnd.setHours(hours, minutes, 0);



    this.addEventForm.patchValue({
      EventStart: newEventStart.toISOString(),
      EventStartUTC: newEventStart.toISOString()
    });
    this.addEventForm.patchValue({
      EventEnd: newEventEnd.toISOString(),
      EventEndUTC: newEventEnd.toISOString()
    });

    const privateControl = this.addEventForm.get('_PRIVATE');
    const privateValue = privateControl ? privateControl.value : null;

    if (privateValue) {
      this.addEventForm.patchValue({ 'Visibility': 'PRIVATE' });
    } else {
      this.addEventForm.patchValue({ 'Visibility': 'ORGANIZATION' });
    }

    if (this.isUpdate) {
      // console.log(this.addEventForm.value);
      this.eventService.updateGenericEvent(this.addEventForm.value).subscribe(result => {

        if (result)
          this.dialogRef.close(true);
      });
    } else {
      // console.log(this.addEventForm.value);
      this.eventService.addGenericEvent(this.addEventForm.value).subscribe(result => {
        if (result)
          this.dialogRef.close(true);
      });
    }

  }

  close() {
    this.dialogRef.close(false);
  }
}

export function dateAfterStartValidator(startDateField: string) {
  return (control: AbstractControl): ValidationErrors | null => {
    const startDate = control.parent?.get(startDateField)?.value;
    const endDate = control.value;

    if (!startDate || !endDate) {
      return null; // Om ett av fälten är tomt, ingen validering utförs.
    }

    return new Date(startDate) <= new Date(endDate) ? null : { dateOrder: true };
  };
}
